function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.38889 16.8605H23.6111C24.375 16.8605 25 16.2282 25 15.4554C25 14.6827 24.375 14.0504 23.6111 14.0504H1.38889C0.625 14.0504 0 14.6827 0 15.4554C0 16.2282 0.625 16.8605 1.38889 16.8605ZM1.38889 9.83527H23.6111C24.375 9.83527 25 9.203 25 8.43023C25 7.65746 24.375 7.02519 23.6111 7.02519H1.38889C0.625 7.02519 0 7.65746 0 8.43023C0 9.203 0.625 9.83527 1.38889 9.83527ZM0 1.40504C0 2.17781 0.625 2.81008 1.38889 2.81008H23.6111C24.375 2.81008 25 2.17781 25 1.40504C25 0.632267 24.375 0 23.6111 0H1.38889C0.625 0 0 0.632267 0 1.40504Z",
  fill: "black"
});

function SvgHamburger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 17,
    viewBox: "0 0 25 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.88b21d82.svg";
export { ForwardRef as ReactComponent };